import { HttpErrorResponse } from "@angular/common/http";

export const handleError = (
  err: HttpErrorResponse,
): {
  message: string;
  code: string;
  response: Record<string, unknown> | null;
} => {
  const { message = "Erro ao realizar requisição. Tente novamente!", code = "" } =
    err?.error?.error || err.error;

  return { message, code, response: err?.error ?? null };
};
